export const containsOutsideLatin1 = (val: string) => {
  return /[^\x00-\xFF]/.test(val)
}
